import { useState } from "react";
import branding from "./branding";
import { API_BASE_URL } from "./apiConfig";

function Login({ onLogin, onOpenRegister, onLanguageChange }) {
  const [language, setLanguage] = useState("af");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    if (!email || !password) {
      alert(
        language === "af"
          ? "Vul asseblief al die velde in."
          : "Please complete all fields."
      );
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(
          language === "af"
            ? data.message || "Aanmelding het misluk."
            : data.message || "Login failed."
        );
        return;
      }

      const sessionUser = {
        ...data.user,
        preferredLanguage: language,
      };

      localStorage.setItem("chemMasterToken", data.token);
      localStorage.setItem(
        "chemMasterUser",
        JSON.stringify(sessionUser)
      );

      onLogin(sessionUser, language);
    } catch (error) {
      console.error("Login request failed:", error);

      alert(
        language === "af"
          ? "Aanmelding kon nie voltooi word nie. Probeer asseblief weer."
          : "Login could not be completed. Please try again."
      );
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      alert(
        language === "af"
          ? "Vul asseblief jou e-posadres in."
          : "Please enter your email address."
      );
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/forgot-password`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            email,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(
          language === "af"
            ? data.message ||
            "Die wagwoordherstelversoek het misluk."
            : data.message ||
            "The password-reset request failed."
        );
        return;
      }

      alert(
        language === "af"
          ? "As ’n rekening vir hierdie e-posadres bestaan, is ’n wagwoordherstel-skakel gestuur."
          : data.message
      );
    } catch (error) {
      console.error(
        "Password reset request failed:",
        error
      );

      alert(
        language === "af"
          ? "Die wagwoordherstelversoek kon nie voltooi word nie."
          : "The password-reset request could not be completed."
      );
    }
  };


  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f3f6fb",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "40px",
          borderRadius: "15px",
          width: "100%",
          maxWidth: "400px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
        }}
      >

        <div
          style={{
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          <img
            src="/ScienceTutor.png"
            alt="Science Tutor logo"
            style={{
              width: "190px",
              maxWidth: "100%",
              height: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>

        <p style={{ textAlign: "center", color: "#666" }}>
          {language === "af"
            ? "Graad 12 Chemie. Slimmer leer. Sterker presteer."
            : "Grade 12 Chemistry. Learn smarter. Achieve more."}
        </p>

        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <p
            style={{
              marginBottom: "10px",
              color: "#555",
              fontWeight: "bold",
            }}
          >
            Kies taal / Select language
          </p>

          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <button
              type="button"
              onClick={() => { setLanguage("af"); onLanguageChange("af"); }}
              style={{
                flex: 1,
                padding: "10px",
                background:
                  language === "af"
                    ? branding.primaryColor
                    : "#dbeafe",
                color:
                  language === "af"
                    ? "white"
                    : branding.primaryColor,
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Afrikaans
            </button>

            <button
              type="button"
              onClick={() => {
                setLanguage("en");
                onLanguageChange("en");
              }}
              style={{
                flex: 1,
                padding: "10px",
                background:
                  language === "en"
                    ? branding.primaryColor
                    : "#dbeafe",
                color:
                  language === "en"
                    ? "white"
                    : branding.primaryColor,
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              English
            </button>
          </div>
        </div>

        <input
          type="email"
          placeholder={language === "af" ? "E-posadres" : "Email address"}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "20px",
            boxSizing: "border-box",
          }}
        />

        <input
          type="password"
          placeholder={language === "af" ? "Wagwoord" : "Password"}
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "15px",
            boxSizing: "border-box",
          }}
        />

        <button
          type="button"
          onClick={handleForgotPassword}
          style={{
            display: "block",
            width: "100%",
            marginTop: "12px",
            padding: "0",
            background: "transparent",
            border: "none",
            color: branding.primaryColor,
            cursor: "pointer",
            textAlign: "right",
            fontWeight: "bold",
          }}
        >
          {language === "af"
            ? "Wagwoord vergeet?"
            : "Forgot password?"}
        </button>

        <button
          type="button"
          onClick={handleLogin}
          style={{
            width: "100%",
            padding: "12px",
            marginTop: "20px",
            background: branding.primaryColor,
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          {language === "af" ? "Teken in" : "Sign in"}
        </button>

        <p
          style={{
            textAlign: "center",
            marginTop: "24px",
            marginBottom: "8px",
            color: "#666",
          }}
        >
          {language === "af"
            ? "Nuut by ChemMaster SA?"
            : "New to ChemMaster SA?"}
        </p>

        <button
          type="button"
          onClick={() => onOpenRegister(language)}
          style={{
            width: "100%",
            background: "transparent",
            border: "none",
            color: branding.primaryColor,
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          {language === "af"
            ? "Skep 'n rekening"
            : "Create an account"}
        </button>
      </div>
    </div>
  );
}

export default Login;
